<template>
    <div class="modal-window krs017">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.OtherProjectBoardLink.001","타 과제 보드 링크") }}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="info-txt">{{ $i18nUtil.trans("message.OtherProjectBoardLink.001","다른 과제에서 생성한 보드 URL을 복사하여, 현재 과제에 링크해서 이용해 보세요.") }}</div>
            <div class="info-txt smaller">{{ $i18nUtil.trans("message.OtherProjectBoardLink.002","* 보드 URL은 보드화면 상단 “●●●” 을 클릭하여 복사하실 수 있습니다.") }}</div>

            <div class="tooltip-b tl small" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display, 'bottom': tooltip.bottom, 'width': tooltip.width, 'left': tooltip.left}" style="position: absolute">
                {{ tooltipCategoryName == null ? "" : tooltipCategoryName }}
            </div>

            <div class="dropdown ty2 wide relative">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" class="ell-singleline" :class="(selectedProjectFolder == null || selectedProjectFolder.categoryMid == null) ? 'disabled' : ''">
                            {{
                                (selectedProjectFolder == null || selectedProjectFolder.categoryMid == null)
                                ? $i18nUtil.trans("message.OtherProjectBoardLink.007","현재 과제 내 과정 선택") : selectedProjectFolder.categoryName
                            }}
                        </v-btn>
                    </template>
                    <div class="dropdown-list">
                        <div class="scroll">
                            <div class="dropdown-list-item" v-if="projectFolderList == null || projectFolderList.length == 0">
                                <div class="tit">
                                    <button 
                                        type="button" 
                                        :class="(selectedProjectFolder == null || selectedProjectFolder.categoryMid == null) ? 'active' : ''"
                                        :value="{}"
                                        @click="changeProjectFolder(null, 'dtProjectFolder')"
                                    >{{$i18nUtil.trans("search.014","등록된 과정이 없습니다.")}}</button>
                                </div>
                            </div>
                            <div 
                                class="dropdown-list-item"
                                v-for="(projectFolderItem, projectFolderIndex) in projectFolderList"
                                :value="projectFolderItem"
                                :key="projectFolderIndex"
                                @click="changeProjectFolder(projectFolderItem, 'dtProjectFolder')"
                                v-else
                            >
                                <div class="tit">
                                    <button 
                                        type="button" class="ell-singleline"
                                        :class="(selectedProjectFolder != null && selectedProjectFolder.categoryMid == projectFolderItem.categoryMid) ? 'active' : ''"
                                        @mouseover="mouseEvt(true, projectFolderItem.categoryName, $event)"
                                        @mouseleave="mouseEvt(false, null, $event)"
                                    >
                                        {{ projectFolderItem.categoryName }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-menu>
            </div>
            <!-- <dl class="dl_layer select_ty3 scroll full">
                <dt id="dtProjectFolder">
                    <button 
                        type="button" 
                        @click="$event.target.parentElement.classList.toggle('active');"
                    >
                        {{
                            (selectedProjectFolder == null || selectedProjectFolder.categoryMid == null)
                            ? '현재 내  선택' : selectedProjectFolder.categoryName
                        }}
                    </button>
                </dt>
                <dd>
                    <ul>
                        <li 
                            :value="{}"
                            @click="changeProjectFolder(null, 'dtProjectFolder')"
                        >
                            <button type="button">현재 내  선택</button>
                        </li>
                        <li
                            v-for="(projectFolderItem, projectFolderIndex) in projectFolderList"
                            :value="projectFolderItem"
                            :key="projectFolderIndex"
                            @click="changeProjectFolder(projectFolderItem, 'dtProjectFolder')"
                        >
                            <button type="button">
                                {{ projectFolderItem.categoryName }}
                            </button>
                        </li>
                    </ul>
                </dd>
            </dl> -->
            <div class="error" v-if="error">{{$i18nUtil.trans("message.OtherProjectBoardLink.003","과정을 선택해주세요.")}}</div>

            <form action="" @submit.prevent="false == false">
                <div class="input-box">
                    <input 
                        type="text" 
                        required 
                        :placeholder="$i18nUtil.trans('message.OtherProjectBoardLink.004','복사한 보드 URL을 붙여 넣기 하세요.')" 
                        v-model="copyBoardUrl" 
                        @input="copyBoardUrl = $event.target.value, boardUrlError = false"
                        autocomplete="off"
                    />
                    <button type="reset" class="input-txt-del" @click="copyBoardUrl = ''">입력 삭제</button>
                    <div class="error" v-if="boardUrlError">{{$i18nUtil.trans('UB050')}}</div>
                </div>
            </form>

        </div>

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="saveBoardLinkProject()">{{ $i18nUtil.trans("button.add","추가") }}</button>
        </footer>
    </div>
</template>
<script>

import { mapActions } from "vuex";
import axios from "axios";

export default {
    components: {
    },
    props: {
      modalInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
        return { 
            error: false,
            boardUrlError: false,
            groupId: this.modalInfo.groupId,
            projectId: this.modalInfo.projectId,
            /* 폴더 */
            projectFolderList: [],
            selectedProjectFolder: {},
            copyLinkPaperId: null,
            copyBoardUrl: "",
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
            hover: false,
            tooltipFlag: false,
            tooltipCategoryName: null,
            tooltip: {
                zIndex: 0,
                display: 'none',
                bottom: '0px',
                width: '0px',
                left: '30px'
            }
        };
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showToast"]),

        /* tooltip */
        mouseEvt(flag, categoryName, event) {
            this.hover = flag;
            this.tooltipCategoryName = categoryName
            // let val = this.$tooltip.checkTabLength(categoryName, 100)
            let val = this.$tooltip.hasOverflownModalSelectBox(event.target)
            this.tooltipFlag = this.hover == true && val == true ? true : false
            this.activateTooltip(this.tooltipFlag, event);
        },
        activateTooltip(val, event) {
            let modalStyle = document.getElementsByClassName("v--modal-box")[0].getBoundingClientRect() // 모달의 style 정보;
            let loc = event.target.getBoundingClientRect().top; // 마우스 오버 타겟의 top
            loc = Math.abs(loc - modalStyle.bottom);
            // console.log("################ > ", loc);
            let width = event.target.getBoundingClientRect().width;

            if(val) {
                this.tooltip.zIndex = 13;
                this.tooltip.display = "inline-block";
                this.tooltip.width = width+'px';
                this.tooltip.bottom = loc+'px';
            }else{
                this.tooltip.zIndex = 0;
                this.tooltip.display = "none";
                this.tooltip.width = '0px';
                this.tooltip.bottom = '0px';
            }
        },

        /* 변경 */
        initCategoryItemList() {
            let obj = this;
            if(obj.groupId != null && obj.projectId != null && obj.projectId != undefined) {
                let projectFolderUrl = "/api/copaper/category/getCategoryItemList";
                let param = {
                    categoryMid: null,
                    groupId: obj.groupId,
                    type: "PROJECT"
                };
                axios
                    .post(projectFolderUrl, param)
                    .then((res) => {
                        if (res.errorCode != null && res.errorCode != undefined) {
                            alert(res.errorCode);
                            return;
                        }
                        obj.projectFolderList = res.data.result;
                    })
                    .catch((err) => {
                        console.log("axios err => ", err);
                    });
            } else {
                // obj.moreClose("dtProjectFolder");
                obj.projectFolderList = [];
            }
        },
        /* 내 단계 변경 */
        changeProjectFolder(projectFolderInfo, dtId) {
            let obj = this;
            obj.error = false;
            obj.boardUrlError = false;
            obj.selectedProjectFolder = projectFolderInfo;
            // obj.moreClose(dtId);
        },
        // moreClose(targetId) {
        //     if(document.getElementById(targetId).classList.contains("active")) {
        //         document.getElementById(targetId).classList.toggle("active");
        //     }
        // },
        saveBoardLinkProject() {
            let obj = this;
            if(obj.selectedProjectFolder == null || obj.selectedProjectFolder.categoryMid == null) {
                obj.error = true;
                return;
            }

            // board url validate
            /* 현재 url */
            let url = obj.copyBoardUrl;
            let match = /^(.+)\/(board)\/(PAPE[a-zA-Z0-9]+)$/.exec(url);
            if(match == null) {
                match = /^(.+)\/(board)\/(PAPE[a-zA-Z0-9]+)(\/[0-9]+)/.exec(url);
            }
            if (match == null || match.length < 4) {
                obj.boardUrlError = true;
                return;
            }

            obj.copyLinkPaperId = (match.length == 4 ? match[3] : match[4]);

            obj.boardUrlError = false;
            if(obj.copyLinkPaperId == null || obj.copyLinkPaperId == null) {
                obj.boardUrlError = true;
                return;
            }

            let saveUrl = "/api/copaper/paperlink/saveBoardLinkProject";
            let param = {
                paperId: obj.copyLinkPaperId,
                projectId: obj.selectedProjectFolder.projectId,
                groupId: obj.selectedProjectFolder.groupId,
                categoryMid: obj.selectedProjectFolder.categoryMid,
            };
            axios
                .post(saveUrl, param)
                .then((res) => {
                    if (res.data.errorCode != null && res.data.errorCode != undefined) {
                        if(res.data.errorCode == "SAVE_FAIL_ALREADY_EXISTS") {
                            // 이미 등록된 링크입니다.
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089");
                        }
                        else if(res.data.errorCode == "SAVE_FAIL_PAPER_CATEGORY_MID_REQUIRED") {
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089.001");
                        }
                        else if(res.data.errorCode == "SAVE_FAIL_SAME_CATEGORY_MID") {
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089.002");
                        }
                        else if(res.data.errorCode == "SAVE_FAIL_GROUP_KBN") {
                            // 2021-01-19 토스트 대신 input 에러로 보여주기로 함.
                            obj.boardUrlError = true;
                        }
                        obj.showToast(obj.toastInfo);
                        return;
                    }
                    obj.selectedProjectFolder = {};
                    // 링크가 등록되었습니다.
                    obj.toastInfo.message = obj.$i18nUtil.trans("TB090");
                    obj.showToast(obj.toastInfo);
                    obj.$emit("closeOtherProjectBoardLink");
                    obj.$emit("close");
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
    },
    mounted() {
        this.initCategoryItemList();
    },
}
</script>

<style scoped>
.tooltip-b.tl::before, .tooltip-w.tl::before {
  top: auto;
  bottom: -6px;
  -webkit-transform: rotate(
    180deg
  );
  transform: rotate(
    180deg
    );
}
.krs017 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b::before {
    top: auto; bottom: -8px;
    transform: rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/OtherProjectBoardLink.vue